import { scale } from '@utils/normalize';
import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  contentContainerStyle: { paddingBottom: scale(30) },
  imageContainer: { alignItems: 'center', height: scale(140), justifyContent: 'center' },
  imageStyle: { height: '100%', width: '100%' },
});
export default styles;
